// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2712%27 viewBox=%270 0 16 12%27 fill=%27none%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M4 5L8 9L12 5%27 stroke=%27%236e93f5%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modern-graph-card {
  /* max-width: 700px; */
  margin: 2.5rem auto;
  padding: 2.6rem 2.3rem 1.2rem 2.3rem;
  border-radius: 24px;
  background: rgba(255,255,255,0.38);
  backdrop-filter: blur(6px);
  box-shadow: 0 8px 38px rgba(180,180,255,0.18);
  font-family: 'Poppins', 'Segoe UI', sans-serif;
  position: relative;
}

.modern-graph-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1.4rem;
  gap: 1.2rem;
}

.modern-pill-group {
  display: flex;
  gap: 1rem;
}

.modern-pill {
  border: none;
  border-radius: 23px;
  padding: 0.55rem 2.2rem;
  font-size: 1rem;
  font-weight: 600;
  color: #5a5e97;
  background: linear-gradient(90deg, #e6e0fc, #fff8ee);
  box-shadow: 0 3px 18px rgba(130, 104, 200, 0.13);
  cursor: pointer;
  transition: box-shadow 0.17s, background 0.2s, color 0.17s;
}
.modern-pill.active {
  background: linear-gradient(90deg, #9092fb 0%, #4e54c8 100%);
  color: #fff;
  box-shadow: 0 3px 18px rgba(130, 104, 200, 0.21);
}

.modern-graph-title {
  font-size: 1.8rem;
  font-weight: bold;
  margin: 0 0 1.3rem 0;
  color: #23243a;
  letter-spacing: 0.03em;
}

.modern-graph-legend-row {
  display: flex;
  gap: 1.2rem;
  margin-top: 1.8rem;
  margin-bottom: 0.8rem;
  width: 100%;
  justify-content: center;
}
.modern-graph-legend-card {
  background: rgba(255,255,255,0.77);
  border-radius: 14px;
  box-shadow: 0 6px 16px rgba(200,201,250,0.09);
  padding: 1.1rem 1.5rem 0.8rem 1.1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 140px;
}
.legend-dot {
  width: 16px;
  height: 16px;
  margin-bottom: 0.4rem;
  border-radius: 50%;
  box-shadow: 0 0 10px 0px #e6e0fc;
}
.legend-title {
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 0.18rem;
  color: #272a55;
}
.legend-desc {
  font-size: 0.93rem;
  color: #9696b2;
}

.modern-graph-disclaimer {
  margin-top: 1.5rem;
  color: #979191;
  font-size: 0.99rem;
  text-align: left;
  letter-spacing: 0.018em;
  padding-bottom: 0.7rem;
}

/* Responsive */
@media (max-width: 800px) {
  .modern-graph-card {
    max-width: 98vw;
    padding: 1.3rem 0.7rem 1.1rem 0.7rem;
  }
  .modern-graph-legend-card { min-width: 78px; padding: 0.7rem 0.5rem 0.5rem 0.7rem }
  .modern-graph-legend-row { gap: 0.5rem }
  .modern-pill { padding: 0.35rem 1rem; font-size: 0.88rem; }
}


.modern-select-row {
  display: flex;
  gap: 1.2rem;
  margin-bottom: 1.3rem;
}

.modern-select {
  appearance: none;
  font-size: 1.1rem;
  font-weight: 600;
  padding: 0.55rem 2rem 0.55rem 1.2rem;
  border-radius: 18px;
  background: linear-gradient(90deg, #f6f7fd, #eaefff 98%);
  color: #3b3f5c;
  border: 2px solid #e3e7fc;
  box-shadow: 0 2px 20px rgba(129,147,218,0.13);
  outline: none;
  transition: border-color 0.22s;
  min-width: 120px;
  margin: 0;
}

.modern-select:focus {
  border-color: #6e93f5;
  background: linear-gradient(90deg, #e0ebfd 0%, #f6f7fd 100%);
  color: #21243d;
}

.modern-select option {
  font-size: 1rem;
  background: #fff;
  color: #26274a;
  border-radius: 8px;
  padding: 0.4rem 1rem;
}

/* Optional: custom dropdown arrow */
.modern-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 1.1em center;
  background-size: 1.1em;
  padding-right: 2.2em;
}


.modern-graph-disclaimer {
  margin-top: 1.7rem;
  padding: 1rem 2rem;
  border-radius: 18px;
  background: #f0f4ff;
  box-shadow: inset 0 0 10px #bac8ff;
  font-weight: 500;
  font-size: 0.95rem;
  color: #4f529d;
  display: flex;
  align-items: center;
  gap: 0.7rem;
  -webkit-user-select: none;
          user-select: none;
  letter-spacing: 0.02em;
}

.disclaimer-icon {
  width: 18px;
  height: 18px;
  color: #6471ff;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  width: 100%; /* Optional: ensures full-width alignment */
  padding-top: 20px; /* Optional: adds space above the button */
}
`, "",{"version":3,"sources":["webpack://./src/styles/armygraph.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,kCAAkC;EAClC,0BAA0B;EAC1B,6CAA6C;EAC7C,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oDAAoD;EACpD,gDAAgD;EAChD,eAAe;EACf,0DAA0D;AAC5D;AACA;EACE,4DAA4D;EAC5D,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,6CAA6C;EAC7C,oCAAoC;EACpC,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE;IACE,eAAe;IACf,oCAAoC;EACtC;EACA,4BAA4B,eAAe,EAAE,qCAAqC;EAClF,2BAA2B,YAAY;EACvC,eAAe,qBAAqB,EAAE,kBAAkB,EAAE;AAC5D;;;AAGA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,mBAAmB;EACnB,wDAAwD;EACxD,cAAc;EACd,yBAAyB;EACzB,6CAA6C;EAC7C,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,4DAA4D;EAC5D,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,oCAAoC;AACpC;EACE,yDAAyQ;EACzQ,4BAA4B;EAC5B,uCAAuC;EACvC,sBAAsB;EACtB,oBAAoB;AACtB;;;AAGA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW,EAAE,2CAA2C;EACxD,iBAAiB,EAAE,0CAA0C;AAC/D","sourcesContent":[".modern-graph-card {\n  /* max-width: 700px; */\n  margin: 2.5rem auto;\n  padding: 2.6rem 2.3rem 1.2rem 2.3rem;\n  border-radius: 24px;\n  background: rgba(255,255,255,0.38);\n  backdrop-filter: blur(6px);\n  box-shadow: 0 8px 38px rgba(180,180,255,0.18);\n  font-family: 'Poppins', 'Segoe UI', sans-serif;\n  position: relative;\n}\n\n.modern-graph-top {\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  margin-bottom: 1.4rem;\n  gap: 1.2rem;\n}\n\n.modern-pill-group {\n  display: flex;\n  gap: 1rem;\n}\n\n.modern-pill {\n  border: none;\n  border-radius: 23px;\n  padding: 0.55rem 2.2rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: #5a5e97;\n  background: linear-gradient(90deg, #e6e0fc, #fff8ee);\n  box-shadow: 0 3px 18px rgba(130, 104, 200, 0.13);\n  cursor: pointer;\n  transition: box-shadow 0.17s, background 0.2s, color 0.17s;\n}\n.modern-pill.active {\n  background: linear-gradient(90deg, #9092fb 0%, #4e54c8 100%);\n  color: #fff;\n  box-shadow: 0 3px 18px rgba(130, 104, 200, 0.21);\n}\n\n.modern-graph-title {\n  font-size: 1.8rem;\n  font-weight: bold;\n  margin: 0 0 1.3rem 0;\n  color: #23243a;\n  letter-spacing: 0.03em;\n}\n\n.modern-graph-legend-row {\n  display: flex;\n  gap: 1.2rem;\n  margin-top: 1.8rem;\n  margin-bottom: 0.8rem;\n  width: 100%;\n  justify-content: center;\n}\n.modern-graph-legend-card {\n  background: rgba(255,255,255,0.77);\n  border-radius: 14px;\n  box-shadow: 0 6px 16px rgba(200,201,250,0.09);\n  padding: 1.1rem 1.5rem 0.8rem 1.1rem;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  min-width: 140px;\n}\n.legend-dot {\n  width: 16px;\n  height: 16px;\n  margin-bottom: 0.4rem;\n  border-radius: 50%;\n  box-shadow: 0 0 10px 0px #e6e0fc;\n}\n.legend-title {\n  font-weight: 700;\n  font-size: 1rem;\n  margin-bottom: 0.18rem;\n  color: #272a55;\n}\n.legend-desc {\n  font-size: 0.93rem;\n  color: #9696b2;\n}\n\n.modern-graph-disclaimer {\n  margin-top: 1.5rem;\n  color: #979191;\n  font-size: 0.99rem;\n  text-align: left;\n  letter-spacing: 0.018em;\n  padding-bottom: 0.7rem;\n}\n\n/* Responsive */\n@media (max-width: 800px) {\n  .modern-graph-card {\n    max-width: 98vw;\n    padding: 1.3rem 0.7rem 1.1rem 0.7rem;\n  }\n  .modern-graph-legend-card { min-width: 78px; padding: 0.7rem 0.5rem 0.5rem 0.7rem }\n  .modern-graph-legend-row { gap: 0.5rem }\n  .modern-pill { padding: 0.35rem 1rem; font-size: 0.88rem; }\n}\n\n\n.modern-select-row {\n  display: flex;\n  gap: 1.2rem;\n  margin-bottom: 1.3rem;\n}\n\n.modern-select {\n  appearance: none;\n  font-size: 1.1rem;\n  font-weight: 600;\n  padding: 0.55rem 2rem 0.55rem 1.2rem;\n  border-radius: 18px;\n  background: linear-gradient(90deg, #f6f7fd, #eaefff 98%);\n  color: #3b3f5c;\n  border: 2px solid #e3e7fc;\n  box-shadow: 0 2px 20px rgba(129,147,218,0.13);\n  outline: none;\n  transition: border-color 0.22s;\n  min-width: 120px;\n  margin: 0;\n}\n\n.modern-select:focus {\n  border-color: #6e93f5;\n  background: linear-gradient(90deg, #e0ebfd 0%, #f6f7fd 100%);\n  color: #21243d;\n}\n\n.modern-select option {\n  font-size: 1rem;\n  background: #fff;\n  color: #26274a;\n  border-radius: 8px;\n  padding: 0.4rem 1rem;\n}\n\n/* Optional: custom dropdown arrow */\n.modern-select {\n  background-image: url(\"data:image/svg+xml,%3Csvg width='16' height='12' viewBox='0 0 16 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M4 5L8 9L12 5' stroke='%236e93f5' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 1.1em center;\n  background-size: 1.1em;\n  padding-right: 2.2em;\n}\n\n\n.modern-graph-disclaimer {\n  margin-top: 1.7rem;\n  padding: 1rem 2rem;\n  border-radius: 18px;\n  background: #f0f4ff;\n  box-shadow: inset 0 0 10px #bac8ff;\n  font-weight: 500;\n  font-size: 0.95rem;\n  color: #4f529d;\n  display: flex;\n  align-items: center;\n  gap: 0.7rem;\n  user-select: none;\n  letter-spacing: 0.02em;\n}\n\n.disclaimer-icon {\n  width: 18px;\n  height: 18px;\n  color: #6471ff;\n}\n\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  width: 100%; /* Optional: ensures full-width alignment */\n  padding-top: 20px; /* Optional: adds space above the button */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
